import React from "react";
import useInView from "../../hooks/useInView";
import styles from "./Reveal.module.css";

/**
 * Quiet scroll-entry wrapper.
 * Content fades up 14px once, then stays put. The animation is declared as a
 * CSS animation (not a transition) so hover states on the same element keep
 * their own transitions intact.
 */
const Reveal = ({ as: Tag = "div", delay = 0, className = "", children, ...rest }) => {
  const [ref, inView] = useInView();

  return (
    <Tag
      ref={ref}
      className={[styles.reveal, inView ? styles.visible : "", className].filter(Boolean).join(" ")}
      style={{ "--reveal-delay": `${delay}ms` }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;